import { createFileRoute } from '@tanstack/react-router';
import { ArtistsPage } from '@/components/marketing/pages/ArtistsPage';

export const Route = createFileRoute('/_marketing/for-artists')({
  component: ArtistsPage,
});
